import { Logger } from './Logger';

const _generateKey = (suffix: string) => (`@foongit-${suffix}`);

export class Storage {

  static clearUser(): void {
    Storage._removeItem('token');
  }

  static storeUserToken(token: string): void {
    Storage._setItem('token', token);
  }

  static getUserToken(): any {
    return Storage._getItem('token');
  }

  private static _getItem(key: string): any {
    try {
      const item = window.localStorage.getItem(_generateKey(key));
      if (item) {
        return JSON.parse(item);
      } else {
        return undefined;
      }
    } catch (error) {
      Logger.handleError(error);
      return undefined;
    }
  }

  private static _setItem(key: string, item: any): void {
    const value = item ? JSON.stringify(item) : '';
    window.localStorage.setItem(_generateKey(key), value);
  }

  private static _removeItem(key: string): void {
    window.localStorage.removeItem(_generateKey(key));
  }
}
